import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M13.144 4.664a.75.75 0 1 1 0 1.5h-7.1a1.5 1.5 0 0 0-1.5 1.5v.008l-.094 9.25a1.5 1.5 0 0 0 1.5 1.492h10.2a1.5 1.5 0 0 0 1.5-1.5v-5.8a.75.75 0 1 1 1.5 0v5.8a3 3 0 0 1-3 3H5.95a3 3 0 0 1-3-3v-.007l.094-9.25a3 3 0 0 1 3-2.993zm8.406 3.65a.75.75 0 1 1-1.5 0V4.875L9.58 15.345a.75.75 0 0 1-1.061-1.061l10.47-10.47h-3.44a.75.75 0 1 1 0-1.5h5.25a.75.75 0 0 1 .75.75v5.25z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const ArrowTopRightOnSquareIcon = ForwardRef;